import { create } from "zustand";

export interface IWalkthroughState {
    openWalkthrough: boolean;
    setOpenWalkthrough: (open: boolean) => void;
    step: number;
    anchorEl2: HTMLElement | null;
    setStep: (step: number) => void;
    setAnchorEl2: (el: HTMLElement | null) => void;
    reset: () => void;
    selectedStep: string;
    setSelectedStep: (step: string) => void;
}

const useWalkthroughState = create<IWalkthroughState>((set) => ({
    step: 0,
    anchorEl2: null,
    selectedStep: '',
    openWalkthrough: false,
    setOpenWalkthrough: (open) => set({ openWalkthrough: open }),
    setStep: (step) => set({ step }),
    setAnchorEl2: (el) => set({ anchorEl2: el }),
    reset: () => set({ step: 0, anchorEl2: null, openWalkthrough: false, selectedStep: '' }),
    setSelectedStep: (step) => set({ selectedStep: step }),
}));

export default useWalkthroughState;